module.exports = __webpack_public_path__ + "static/swansea-e5efc60656e8aff8cb3ab3f72e755d00.png";